import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Button, Form } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { useParams, useNavigate } from 'react-router-dom';
import Wrapper from '../../components/Wrapper';
import axiosInstance from '../../utils/axios';
import { getRole } from '../../utils/role';

const sizeUnits = [
  'sq mtr', 'Acres', 'Hectare', 'Bigha', 'Gaj', 'Kanal', 'Biswa', 'Dismil', 'Killa',
  'Marla', 'Nali', 'Guntha', 'Square Karam', 'Ankanam', 'Gajam', 'Chatak',
  'Dhur', 'Perch', 'Lessa', 'Murabba', 'Biswa Kacha', 'Pura'
];

const summaryFields = [
  { name: 'yield date', label: 'yield_date', placeholder: 'Enter Yield Date', type: 'date', disabled: false },
  { name: 'crop', label: 'crop', placeholder: 'Enter Crop', type: 'text', disabled: false },
  { name: 'profit', label: 'profit', placeholder: 'Profit will be calculated', type: 'number', disabled: true },
  { name: 'area', label: 'area', placeholder: 'Enter Area', type: 'number', disabled: false },
  { name: 'area unit', label: 'area_unit', placeholder: 'Enter Area Unit', type: 'text', option: sizeUnits, disabled: false },
  { name: 'total cost', label: 'total_cost', placeholder: 'Total Cost will be calculated', type: 'number', disabled: true },
  { name: 'Sale price of 1 quintal', label: 'per_quintal_sale_price', placeholder: 'Enter Sale Price of 1 quintal', type: 'number', disabled: false },
  { name: 'total quanity', label: 'total_quantity', placeholder: 'Enter Total Quantity', type: 'number', disabled: false },
  { name: 'total revenue', label: 'total_revenue', placeholder: 'Total Revenue will be calculated', type: 'number', disabled: true },
  { name: 'yield per unit', label: 'yield_per_unit', placeholder: 'Enter Yield Per Unit', type: 'number', disabled: false },
  { name: 'remarks', label: 'remarks', placeholder: 'Enter Remarks', type: 'text', disabled: false },
];

const practiceFields = [
  { name: 'fertilizer name', label: 'fertilizer_name', placeholder: 'Enter Fertilizer Name', type: 'text', disabled: false },
  { name: 'total quantity', label: 'total_quantity', placeholder: 'Enter Total Quantity', type: 'number', disabled: false },
  { name: 'per unit cost', label: 'per_unit_cost', placeholder: 'Per Unit Cost will be calculated', type: 'number', disabled: true },
  { name: 'cost of bag', label: 'cost_of_bag', placeholder: 'Enter Cost Of One Bag', type: 'number', disabled: false },
  { name: 'quantity in bag', label: 'quantity_in_bag', placeholder: 'Enter Quantity In Bag', type: 'number', disabled: false },
  { name: 'total cost', label: 'total_cost', placeholder: 'Total Cost will be calculated', type: 'number', disabled: true },
];

function AddPractice() {
  const { id } = useParams();
  const navigate = useNavigate();
  const role = getRole();
  
  const [practiceList, setPracticeList] = useState([]);
  const [basicDetails, setBasicDetails] = useState({});
  const [newPractice, setNewPractice] = useState({});

  const addNewPractice = (e) => {
    let currPrac = { ...newPractice }
    currPrac[e.target.name] = e.target.value
    
    currPrac.per_unit_cost = (currPrac.cost_of_bag && currPrac.quantity_in_bag) 
        ? (parseFloat(currPrac.cost_of_bag) / parseFloat(currPrac.quantity_in_bag)).toFixed(2) 
        : currPrac.per_unit_cost;
        
    currPrac.total_cost = (currPrac.total_quantity && currPrac.per_unit_cost) 
        ? (parseFloat(currPrac.total_quantity) * parseFloat(currPrac.per_unit_cost)).toFixed(2) 
        : currPrac.total_cost;
    
    setNewPractice({ ...currPrac })
  }

  const resetNewPractice = () => {
    setNewPractice({});
  }

  const addBasicDetails = (e) => {
    setBasicDetails({ ...basicDetails, [e.target.name]: e.target.value })
  }

  const resetBasicDetails = () => {
    setBasicDetails({});
  }

  useEffect(() => {
    let total_revenue = (parseFloat(basicDetails.total_quantity) || 0) * (parseFloat(basicDetails.per_quintal_sale_price) || 0);
    setBasicDetails(prev => ({ ...prev, 'total_revenue': total_revenue.toFixed(2) }));
  }, [basicDetails.total_quantity, basicDetails.per_quintal_sale_price]);

  const updateTotalCalculation = (newPracticeArr) => {
    const sumTotalCost = newPracticeArr.reduce(
      (total, currentValue) => total + (parseFloat(currentValue.total_cost) || 0),
      0,
    );
    
    const currProfit = (parseFloat(basicDetails.total_revenue) || 0) - sumTotalCost;
    setBasicDetails(prev => ({ 
        ...prev, 
        'profit': currProfit.toFixed(2), 
        'total_cost': sumTotalCost.toFixed(2) 
    }));
  }

  const addPractice = () => {
    let newPracticeArr = [...practiceList, newPractice]
    setPracticeList(newPracticeArr);
    resetNewPractice();
    updateTotalCalculation(newPracticeArr)
  }

  const deletePractice = (index) => {
    let newPracticeArr = practiceList.filter((practice, i) => i !== index);
    setPracticeList(newPracticeArr);
    updateTotalCalculation(newPracticeArr)
  }

  const savePractice = async (e) => {
    e.preventDefault();
    const data = {
      basic: { ...basicDetails, farmer_id: id },
      practices: practiceList,
    }
    
    try {
      let url = '';
      if (role === 'FIELD_OFFICER') {
          url = `/field-officer/${id}/practice`; 
      } else {
          url = `super-admin/${id}/practice`;
      }

      const response = await axiosInstance.post(url, data);
      console.log(response.data);
      setBasicDetails({});
      setPracticeList([]);
      alert('Practice Added Successfully');
      navigate(-1); 
    } catch (error) {
      console.log(error);
      alert('Failed to save practice');
    }
  }

  return (
    <Wrapper>
      <h1 className='pt-4'>Add a Practice</h1>
      <Row className='g-3'>
        <Col lg={12} className='order-2 order-lg-1'>
          <Card>
            <h4>Basic Details</h4>
            <span><i>Add crop, area etc details.</i></span>
            <br />

            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {summaryFields.map((field, index) => (
                <Col lg={4} key={index} style={{ padding: '1%' }}>
                  <Form.Group>
                    <Form.Label className="text-capitalize">{field.name}</Form.Label>
                    
                    {field.label === 'area_unit' ? (
                        <Form.Select
                            name={field.label}
                            value={basicDetails[field.label] || ''}
                            onChange={addBasicDetails}
                            disabled={field.disabled}
                        >
                            <option value="">Select Unit</option>
                            {sizeUnits.map(unit => (
                                <option key={unit} value={unit}>{unit}</option>
                            ))}
                        </Form.Select>
                    ) : (
                        <Form.Control
                        type={field.type}
                        name={field.label}
                        placeholder={field.placeholder}
                        value={basicDetails[field.label] || ''}
                        disabled={field.disabled}
                        onChange={addBasicDetails}
                        />
                    )}
                  </Form.Group>
                </Col>
              ))}
            </div>
            
            <Row className="mt-3 mb-2">
              <Col lg={12} className="d-flex justify-content-end">
                <Button variant="warning" onClick={resetBasicDetails}>
                  Reset Basic Details
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>

        {/* Practice Inputs */}
        <Col lg={12} className='order-2 order-lg-1'>
          <Card>
            <h4>Practice Details</h4>
            <span><i>Add Fertilizer used details.</i></span>
            <br />

            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {practiceFields.map((field, index) => (
                <Col lg={4} key={index} style={{ padding: '1%' }}>
                  <Form.Group>
                    <Form.Label className="text-capitalize">{field.name}</Form.Label>
                    <Form.Control
                      type={field.type}
                      name={field.label}
                      placeholder={field.placeholder}
                      value={newPractice[field.label] || ''}
                      disabled={field.disabled}
                      onChange={addNewPractice}
                    />
                  </Form.Group>
                </Col>
              ))}
              
              <Row className="w-100 mt-3 mb-2">
                <Col lg={6} className="d-flex justify-content-center">
                  <Button variant="warning" onClick={resetNewPractice}>
                    Reset Practice Details
                  </Button>
                </Col>
                <Col lg={6} className="d-flex justify-content-center">
                  <Button variant="success" onClick={addPractice}>
                    Add Practice Details
                  </Button>
                </Col>
              </Row>
            </div>
          </Card>

          <Card className="mt-3">
            <h4>List of Practice Details</h4>
            <span><i>List of all the practices added.</i></span>
            <br />
            
            {(practiceList.length === 0) ? (
                <div className="text-center"><h5>No Practice Details Added</h5></div>
            ) : (
              <Table responsive striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    {practiceFields.map((field, index) => (
                      <th key={`practice-list` + index} className="text-capitalize">{field.name}</th>
                    ))}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {practiceList.map((practice, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      {practiceFields.map((field, idx) => (
                        <td key={idx}>{practice[field.label]}</td>
                      ))}
                      <td>
                        <Button variant="danger" size="sm" onClick={() => deletePractice(index)}>
                            Delete
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Card>
        </Col>

        {/* Action Buttons */}
        <Col className='order-1 order-lg-2'>
          <Card>
            <Row>
              <Col md={6} className="d-flex justify-content-center">
                <Button variant="warning" style={{ width: '90%' }} onClick={() => window.location.reload()}>
                  Reset All
                </Button>
              </Col>

              <Col md={6} className="d-flex justify-content-center">
                <Button variant="success" style={{ width: '90%' }} onClick={savePractice}>
                  Submit and Save
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>

      </Row>
    </Wrapper>
  );
}

export default AddPractice;